module.exports = "/dist/images/31586460bdd9c191cf49d930e2fb6801-about.jpg";